const d3Category10 = [
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
  '#e377c2',
  '#7f7f7f',
  '#bcbd22',
  '#17becf',
];

const colors = d3Category10;

export function idsToColors(ids: string[]) {
  // We go by date order. The time should be the first 4 bytes of the id
  // Take a copy
  ids = [...ids];
  ids.sort(function (aa, bb) {
    const aaHexTime = aa.slice(0, 8);
    const bbHexTime = bb.slice(0, 8);
    const aaTime = parseInt(aaHexTime, 16);
    const bbTime = parseInt(bbHexTime, 16);

    return aaTime - bbTime;
  });
  const result: Record<string, string> = {};
  ids.forEach((id, index) => {
    index %= colors.length;
    result[id] = colors[index];
  });

  return result;
}
